import { useEffect, useState } from "react";
import MultiSelect from "../../../components/forms/multi-select-drop-down";
import SwitchComponent from "../../../components/switch";
import { listDataSources } from "../../../services/knowledge";
import { useAppInfo } from "../../../helpers/hooks/common-hook";

export default function KbPanel({ toolData, setToolData }) {
	const { appId } = useAppInfo();
	const [kbList, setKbList] = useState([]);

	const fetchKb = async () => {
		try {
			const { response } = await listDataSources(appId);
			const options = (response?.data || []).map((ds) => ({
				id: ds.dataSourceId,
				label: ds.dataSourceId,
				internalId: ds.id,
				fileType: ds.fileType,
			}));
			setKbList(options);
		} catch (_) { }
	};

	useEffect(() => {
		if (appId) fetchKb();
	}, [appId]);

	const selectedKbs = Array.isArray(toolData.filterKb)
		? toolData.filterKb
		: toolData.filterKb
			? [toolData.filterKb]
			: [];

	return (
		<div className="flex flex-col gap-3">
			{/* KB multi-select */}
			<div className="relative">
				<MultiSelect
					label="Filter by Knowledge Base"
					id="filterKb"
					selectedOptions={selectedKbs}
					options={kbList}
					onChangeOptions={(selectedIds) => setToolData({ ...toolData, filterKb: selectedIds })}
				/>
			</div>

			{/* File Read toggle */}
			<div className="pt-1">
				<SwitchComponent
					title="File Read"
					subTitle="Answer by reading the file directly"
					enabled={!!toolData.readFile}
					onChange={(state) => setToolData({ ...toolData, readFile: state })}
				/>
			</div>

			{/* Top K – hidden when readFile is true */}
			{!toolData.readFile && (
				<div>
					<label className="block text-sm font-semibold text-gray-800 mb-1">
						Top Results (topK)
					</label>
					<input
						type="number"
						value={toolData.topK ?? ""}
						onChange={(e) => setToolData({ ...toolData, topK: e.target.value })}
						placeholder="e.g. 5"
						min={1}
						className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary"
					/>
				</div>
			)}
		</div>
	);
}
